import { first } from "rxjs/operators";
import {
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Component, Input, OnInit } from "@angular/core";
import { AlertService } from "@app/_services";
import {
  LazyLoadEvent,
  MessageService,
  ConfirmationService,
} from "primeng/api";
import { MsgCampaign } from "../msg-campaign";
import { MsgCampaignService } from "../msg-campaign.service";
import { MsgCampaignComponent } from "../msg-campaign/msg-campaign.component";

@Component({
    selector: "app-msg-campaign-list",
    templateUrl: "./msg-campaign-list.component.html",
    styleUrls: ["./msg-campaign-list.component.css"],
    providers: [
        MessageService,
        ConfirmationService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ],
    // make column heading sticky
    styles: [
        `
      :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
      }

      @media screen and (max-width: 64em) {
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
          top: 99px;
        }
      }
    `,
    ],
    standalone: false
})
export class MsgCampaignListComponent implements OnInit {
  constructor(
    private msgCampaignService: MsgCampaignService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dialog: MatDialog
  ) {
    this.statuses = msgCampaignService.statuses;
  }

  // data
  @Input() showFilter = true;
  @Input() showPagination = true;
  @Input() outlineNewButton = true;
  msgCampaigns: any;
  msgCampaign: MsgCampaign;

  // paging
  first = 0;
  rows = 50;

  // list
  datasource: any;

  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];

  // forms
  formLoading = false;

  statuses: any;

  columns: any[] = [
    { field: "msgCampaignId", header: "Msg CampaignId", width: "auto" },
    { field: "name", header: "Name", width: "auto" },
    { field: "status", header: "Status", width: "auto" },
    { field: "type", header: "Type", width: "auto" },
    { field: "sendOnDate", header: "Send On Date", width: "auto" },
    { field: "senderName", header: "Sender Name", width: "auto" },
    { field: "senderEmail", header: "sender Email", width: "auto" },
    { field: "senderMobileNum", header: "Sender Mobile Number", width: "auto" },
    // { field: "subject", header: "Subject", width: "auto" },
    // { field: "mobileText", header: "Mobile Text", width: "auto" },
    // { field: "sendByEmail", header: "Send By Email", width: "auto" },
    // { field: "sendBySms", header: "Send By Sms", width: "auto" },
    { field: "opsNotes", header: "Ops Notes", width: "auto" },
    { field: "statusMsg", header: "Status Msg", width: "auto" },
  ];

  ngOnInit(): void {
    try {
      // default sort of list
      this.multiSortMeta = [];
      this.multiSortMeta.push({ field: "createDate", order: 0 });
    } catch (error) {
      console.log("Error: " + error);
    }
  }

  /*********
   * Delete Button
   *
   */
  onRowDelete(event: any) {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " + event.msgCampaignId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete(event);
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  /*********
   * Lazy Load All Data
   *
   */
  loadLazy(event: LazyLoadEvent) {
    try {
      this.loading = true;
      this.lazyLoadEvent = event;

      console.log(
        " event.first:" +
          event.first +
          "  |  event.rows:" +
          event.rows +
          "  |  event.sortField:" +
          event.sortField +
          "  |  event.sortOrder:" +
          event.sortOrder +
          "  |  event.multiSortMeta:" +
          JSON.stringify(event.multiSortMeta) +
          "  |  event.globalFilter:" +
          event.globalFilter +
          "  |  event.filters:" +
          JSON.stringify(event.filters)
      );

      /*
       *
       * Default Sort
       */
      // https://stackoverflow.com/questions/679915/how-do-i-msgCampaign-for-an-empty-javascript-object
      // if we are NOT filtering and we are NOT sorting, apply a default sort
      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: "createDate", order: -1 });
      }

      const pageNumber = Math.round(event.first / event.rows);
      this.msgCampaignService
        .findByFilter(
          pageNumber,
          event.rows,
          event.sortField,
          event.sortOrder,
          event.multiSortMeta,
          event.globalFilter,
          event.filters
        )
        .pipe(first())
        .subscribe(
          (res: any) => {
            this.datasource = res.data.reviews;
            this.recordTotal = res.page.recordTotal;
            this.msgCampaigns = res.data.msgCampaigns;
            console.log(JSON.stringify(res.page));
          },
          (err: any) => {
            console.log("reviews list error!: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
            this.loading = false;
          }
        );

      if (this.datasource) {
        this.msgCampaigns = this.datasource.slice(
          event.first,
          event.first + event.rows
        );
      }
    } catch (error) {
      console.log("loadLazy(" + event + ")" + error);
    }
  }

  getStatus() {
    return;
  }

  /*********
   * onRowSelect()
   * Used to handle row click (to edit, link, etc)
   */
  onRowSelect(event: any) {
    console.log("onRowSelect: " + JSON.stringify(event));
    this.onOpenFormEdit(event.data);
  }

  // handled in rate-bucket-form
  formAdd() {}

  /*********
   * formUpdate()
   * Used for row editing
   */
  formUpdate(msgCampaign: MsgCampaign) {
    try {
      this.formLoading = true;
      this.msgCampaignService.update(msgCampaign).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Update SUCCESS: " + JSON.stringify(res));
          this.msgCampaigns.map((msgCampaign, i) => {
            if (
              msgCampaign.msgCampaignId === res.data.msgCampaign.msgCampaignId
            ) {
              this.msgCampaigns[i] = res.data.msgCampaign;
            }
          });
          // this.alertService.success(res, true);
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Update FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: JSON.stringify(err),
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * formDelete()
   * Used for row editing
   */
  formDelete(msgCampaign: any) {
    try {
      // stop here if form is invalid
      console.log("Delete Submitted: " + JSON.stringify(msgCampaign));

      this.formLoading = true;
      this.msgCampaignService.delete(msgCampaign.msgCampaignId).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Delete SUCCESS: " + JSON.stringify(res));
          this.msgCampaigns.splice(this.msgCampaigns.indexOf(msgCampaign), 1);
          this.recordTotal = this.msgCampaigns.length;
          this.messageService.add({
            severity: "success",
            summary: "Successful",
            detail: "MsgCampaign " + msgCampaign.msgCampaignId + " Deleted",
            life: 3000,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Delete  FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: "Delete Failed",
            detail:
              "MsgCampaign " +
              msgCampaign.msgCampaignId +
              " could not be deleted.  Be sure there are no assigned properties to this bucket.",
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * Add New Button
   *
   */
  onOpenFormAdd() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: "Add MsgCampaign",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(MsgCampaignComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.addMsgCampaignCB(data);

      // close the dialogBox
      // dialogRef.close();
    });
  }

  /*********
   * Edit Button
   *
   */
  onOpenFormEdit(msgCampaign: MsgCampaign) {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      msgCampaign: msgCampaign,
      title: "Edit MsgCampaign",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(MsgCampaignComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.updateMsgCampaignCB(data);

      // close the dialogBox
      // dialogRef.close();
    });

    dialogRef.componentInstance.doDelete.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.deleteMsgCampaignCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /**
   *
   * Dialog from Form Callbacks
   * To edit the list show add/edit/delete in real time from the popup form
   *
   */
  addMsgCampaignCB(msgCampaign: MsgCampaign) {
    console.log("Adding MsgCampaign: " + JSON.stringify(msgCampaign));
    // if we don't have a msgCampaigns array yet...
    if (!this.msgCampaigns) {
      this.msgCampaigns = [];
    }
    // unshift adds to the front of the array (), push adds to the back
    this.msgCampaigns.unshift(msgCampaign);

    // no idea what this is but it is required to update the array
    this.msgCampaigns = [...this.msgCampaigns];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "MsgCampaign " + msgCampaign.msgCampaignId + " Added",
      life: 3000,
    });
  }

  updateMsgCampaignCB(msgCampaign: MsgCampaign) {
    console.log("Updating MsgCampaign: " + JSON.stringify(msgCampaign));
    let itemIndex = this.msgCampaigns.findIndex(
      (item: any) => item.msgCampaignId === msgCampaign.msgCampaignId
    );
    this.msgCampaigns[itemIndex] = msgCampaign;

    // no idea what this is but it is required to update the array
    this.msgCampaigns = [...this.msgCampaigns];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "MsgCampaign " + msgCampaign.msgCampaignId + " Updated",
      life: 3000,
    });
  }

  deleteMsgCampaignCB(msgCampaign: MsgCampaign) {
    console.log("Removing MsgCampaign: " + msgCampaign);
    this.msgCampaigns.splice(this.msgCampaigns.indexOf(msgCampaign), 1);
    this.recordTotal = this.msgCampaigns.length;

    // no idea what this is but it is required to update the array
    this.msgCampaigns = [...this.msgCampaigns];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "MsgCampaign " + msgCampaign.msgCampaignId + " Deleted",
      life: 3000,
    });
  }

  /**********
   *
   * PAGINATOR FUNCTIONS
   */
  next() {
    this.first = this.first + this.rows;
  }
  prev() {
    this.first = this.first - this.rows;
  }
  reset() {
    this.first = 0;
  }
  isLastPage(): boolean {
    return this.msgCampaigns
      ? this.first === this.msgCampaigns.length - this.rows
      : true;
  }
  isFirstPage(): boolean {
    return this.msgCampaigns ? this.first === 0 : true;
  }

  get Statuses() {
    return this.statuses;
  }

  getStatusName(msgCampaign: any) {
    if (msgCampaign?.status) {
      const status = this.statuses.find(
        (e: any) => e.value == msgCampaign.status
      );
      return status.name;
    } else {
      return "";
    }
  }

  reloadPage() {
    window.location.reload();
  }

  showPaginator() {
    return true;
  }
}
